declare namespace $ {

	export class $bog_fragile_demo_rename_heir2 extends $bog_fragile_demo_rename_base2 {
		heading( ): string
	}
	
}

//# sourceMappingURL=heir2.view.tree.d.ts.map